import { useEffect } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { AuthService } from 'services/auth.service';
import useAppDispatch from 'hooks/useAppDispatch';
import { getUserAction } from 'store/modules/auth/actions';
import { setCookieSessionToken } from 'utils/session';
import ScreenLoading from 'components/organisms/ScreenLoading';
import { ROUTES } from 'utils/constants';

const InvitedUser = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();

  const [searchParams, setSearchParams] = useSearchParams();

  const token = searchParams.get('token');

  useEffect(() => {
    if (token) {
      AuthService.memberAcceptInvite(token)
        .then((response) => {
          const { token: newToken } = response.data;

          setCookieSessionToken(newToken);

          dispatch(
            getUserAction(newToken, () => {
              searchParams.delete('token');
              setSearchParams(searchParams);
              navigate(`${ROUTES.REQUIREMENTS}${location.search}`);
            })
          );
        })
        .catch(() => {
          navigate(`${ROUTES.AUTHENTICATION}${location.search}`);
        });
    }
  }, []);

  return <ScreenLoading />;
};

export default InvitedUser;
